import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogsPUsersInput,
    LogsPUsers,
    UpdateLogsPUsersInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class LogsPUsersService {
    private amplifyClient = generateClient();

    async listLogsPUsers(): Promise<LogsPUsers[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogsPUsers
                })
            ).data.listLogsPUsers.items;
            if (data) return data as LogsPUsers[];
        } catch (error) {
            console.error('Error finding LogsPUsers:', error);
            return null;
        }
    }

    async listLogsPUsersByUserId(userId: string): Promise<LogsPUsers[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.LogsPUserByUserEmail,
                    variables: {
                        user: userId
                    }
                })
            ).data.LogsPUserByUserEmail.items;
            if (data) return data as LogsPUsers[];
        } catch (error) {
            console.error('Error finding LogsPUsers by userId:', error);
            return null;
        }
    }

    async createLogsPUsers(input: CreateLogsPUsersInput): Promise<LogsPUsers> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogsPUsers,
                    variables: {
                        input
                    }
                })
            ).data.createLogsPUsers;
            if (data) return data as LogsPUsers;
        } catch (error) {
            console.error('Error creating LogsPUsers:', error);
            return null;
        }
    }

    async updateLogsPUsers(input: UpdateLogsPUsersInput): Promise<LogsPUsers> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogsPUsers,
                    variables: {
                        input
                    }
                })
            ).data.updateLogsPUsers;
            if (client) return client as LogsPUsers;
        } catch (error) {
            console.error('Error updated LogsPUsers:', error);
            return null;
        }
    }
}
